import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'

import type { TrendSoundFilters } from './types'

interface TrendSoundFilterProps {
  filters: TrendSoundFilters
  onFiltersChange: (filters: TrendSoundFilters) => void
  onAddClick: () => void
}

const STATUS_TABS = [
  { label: 'ทั้งหมด', value: '' },
  { label: 'เปิดใช้งาน', value: 'active' },
  { label: 'ซ่อน', value: 'hidden' },
  { label: 'ถูกแบน', value: 'banned' },
] as const

export default function TrendSoundFilter({
  filters,
  onFiltersChange,
  onAddClick,
}: TrendSoundFilterProps) {
  const handleStatusChange = (status: string) => {
    onFiltersChange({
      ...filters,
      status,
      page: 1, // Reset to first page when filtering
    })
  }

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-6">
          {/* Header with Add Button */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-black">รายการเสียงเทรนด์</h2>
            <Button onClick={onAddClick}>เพิ่มเสียงเทรนด์</Button>
          </div>

          <Separator className="border-gray-200" />

          {/* Status Filter Tabs */}
          <div className="flex gap-2 flex-wrap">
            {STATUS_TABS.map((tab) => (
              <Button
                key={tab.value}
                variant={filters.status === tab.value ? 'default' : 'outline'}
                onClick={() => handleStatusChange(tab.value)}
                className={`rounded-lg px-4 py-2 ${
                  filters.status === tab.value
                    ? 'bg-primary text-background'
                    : 'border text-black hover:bg-gray-50'
                }`}
              >
                {tab.label}
              </Button>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
